import React from 'react';
import Button from '@mui/material/Button';
import ColumnBox from 'components/ColumnBox';
import SvgIcon from '@mui/material/SvgIcon';
import AddCircle from '@mui/icons-material/AddCircle';
import Restore from '@mui/icons-material/Restore';
import Person from '@mui/icons-material/Person';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CategoryIcon from '@mui/icons-material/Category';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

import { useNavigate } from 'react-router-dom';

import BigHeading from 'components/BigHeading';
import SmallHeading from 'components/SmallHeading';
import { ReactComponent as StockOutSvg } from 'images/StockOut.svg';
import { ReactComponent as StockInSvg } from 'images/StockIn.svg';

export default function Form(props) {
    const navigate = useNavigate();

    const goToStockIn = function() {
        navigate({ "pathname": "stock_in_entry" })
    }
    const goToStockOut = function() {
        navigate({ "pathname": "stock_out_entry" })
    }
    const goToMealCounts = function() {
        navigate({ "pathname": "meal_counts" })
    }
    const goToStoreProductList = function() {
        navigate({ "pathname": "store_product_list" })
    }
    const goToStoreMenu = function() {
        navigate({ "pathname": "store_menu" })
    }
    const goToStoreReports = function() {
        navigate({ "pathname": "store_reports" })
    }

    return (
        <ColumnBox sx={{ alignItems: 'center' }}>
            <SmallHeading sx={{ textAlign: 'center' }}>{props.warehouse} Manager</SmallHeading>
            <Button sx={{ marginTop: '15px', color: "green", fontWeight: 'bold' }}
                variant="outlined" size="large"
                onClick={() => { goToStockIn() }}
                startIcon={<SvgIcon><StockInSvg /></SvgIcon>}>
                Stock In
            </Button>

            <Button sx={{ marginTop: '15px', color: "red", fontWeight: 'bold' }}
                variant="outlined" size="large"
                onClick={() => { goToStockOut() }}
                endIcon={<SvgIcon><StockOutSvg /></SvgIcon>}>
                Stock Out
            </Button>
            <Button sx={{ marginTop: '15px', fontWeight: 'bold' }}
                variant="outlined" size="large"
                onClick={() => { goToMealCounts() }}
                startIcon={<PeopleAltOutlinedIcon />}>
                Meal Counts
            </Button>
            <hr style={{ borderTop: '1px solid grey', width: '300px' }}/>
            <Button variant="outlined" size="small"
                onClick={() => { goToStoreMenu() }} startIcon={<FactCheckOutlinedIcon />}>
                Menu
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToStoreProductList() }} startIcon={<CategoryIcon />}>
                Store Products
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToStoreReports() }} startIcon={<AssessmentIcon />}>
                Reports
            </Button>
            
        </ColumnBox>
    );
}
